const Error = ({ error, classes }) => {
    return ( <span className={ `error ${classes}` }>{ error }</span> )
}
export default Error;